// extracted by mini-css-extract-plugin
module.exports = {"Legend":"Legend__1f39N","Legend--srOnly":"Legend--srOnly__mMgRJ","Legend--disabled":"Legend--disabled__3KrYl"};